// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3SC-P","options":"AnswerScale_options__1qufb","selected":"AnswerScale_selected__1LjLs"};